import { CancelToken } from "axios";
import { authAxios as axios } from "shared-auth";
import { IBreakdown } from "shared/models/breakdown";

import config from "config/global";

class BreakdownService {
  private url: string;

  constructor({ url }: { url: string }) {
    this.url = url;
  }

  public async get(
    breakdownId: string,
    cancellationToken?: CancelToken
  ): Promise<IBreakdown> {
    const response = await axios(`${this.url}/${breakdownId}`, {
      cancelToken: cancellationToken,
    });
    return response.data;
  }
}

export default new BreakdownService({
  url: config.breakdownsApiUrl,
});
